import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Cookies() {
  return (
    <div className="min-h-screen bg-[#080a0f] text-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-6 py-20 w-full">
        <h1 className="text-3xl font-bold text-white mb-2">Política de Cookies</h1>
        <p className="text-[#6b7280] text-sm mb-10">Última actualización: 1 de abril de 2025</p>

        <div className="space-y-10 text-[#a8b2c1] text-sm leading-relaxed">

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">1. ¿Qué son las cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Permiten que el sitio recuerde sus preferencias y acciones durante un período de tiempo, para que no tenga que volver a introducirlas cada vez que visite el sitio o navegue de una página a otra.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">2. Tipos de cookies que utilizamos</h2>

            <div className="space-y-6">
              <div className="bg-[#0d1117] border border-[#1e2028] rounded-lg p-5">
                <h3 className="text-white font-medium mb-2">Cookies estrictamente necesarias</h3>
                <p className="mb-2">Son imprescindibles para el funcionamiento de la Plataforma. Sin ellas, servicios como el inicio de sesión o la gestión de la suscripción no funcionarían correctamente.</p>
                <div className="mt-3 overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="text-[#6b7280] border-b border-[#1e2028]">
                        <th className="text-left py-2 pr-4">Nombre</th>
                        <th className="text-left py-2 pr-4">Proveedor</th>
                        <th className="text-left py-2">Duración</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1e2028]">
                      <tr>
                        <td className="py-2 pr-4 text-white">sb-auth-token</td>
                        <td className="py-2 pr-4">Supabase</td>
                        <td className="py-2">Sesión</td>
                      </tr>
                      <tr>
                        <td className="py-2 pr-4 text-white">sb-refresh-token</td>
                        <td className="py-2 pr-4">Supabase</td>
                        <td className="py-2">7 días</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="bg-[#0d1117] border border-[#1e2028] rounded-lg p-5">
                <h3 className="text-white font-medium mb-2">Cookies de rendimiento y análisis</h3>
                <p className="mb-2">Nos permiten contar las visitas y fuentes de tráfico para medir y mejorar el rendimiento de la Plataforma. Toda la información que recogen es agregada y, por tanto, anónima.</p>
                <div className="mt-3 overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="text-[#6b7280] border-b border-[#1e2028]">
                        <th className="text-left py-2 pr-4">Nombre</th>
                        <th className="text-left py-2 pr-4">Proveedor</th>
                        <th className="text-left py-2">Duración</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1e2028]">
                      <tr>
                        <td className="py-2 pr-4 text-white">_ga</td>
                        <td className="py-2 pr-4">Google Analytics</td>
                        <td className="py-2">2 años</td>
                      </tr>
                      <tr>
                        <td className="py-2 pr-4 text-white">_ga_*</td>
                        <td className="py-2 pr-4">Google Analytics</td>
                        <td className="py-2">2 años</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="bg-[#0d1117] border border-[#1e2028] rounded-lg p-5">
                <h3 className="text-white font-medium mb-2">Cookies publicitarias</h3>
                <p className="mb-2">Utilizadas por Google AdSense para mostrar anuncios relevantes basados en sus intereses. Estas cookies rastrean su actividad de navegación en diferentes sitios web.</p>
                <div className="mt-3 overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="text-[#6b7280] border-b border-[#1e2028]">
                        <th className="text-left py-2 pr-4">Nombre</th>
                        <th className="text-left py-2 pr-4">Proveedor</th>
                        <th className="text-left py-2">Duración</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1e2028]">
                      <tr>
                        <td className="py-2 pr-4 text-white">__gads</td>
                        <td className="py-2 pr-4">Google AdSense</td>
                        <td className="py-2">13 meses</td>
                      </tr>
                      <tr>
                        <td className="py-2 pr-4 text-white">IDE</td>
                        <td className="py-2 pr-4">Google DoubleClick</td>
                        <td className="py-2">13 meses</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">3. Cómo gestionar las cookies</h2>
            <p className="mb-3">
              Puede configurar su navegador para rechazar todas o algunas cookies, o para que le avise cuando los sitios web establezcan o accedan a cookies. Tenga en cuenta que si deshabilita o rechaza las cookies, algunas partes de la Plataforma pueden volverse inaccesibles o no funcionar correctamente.
            </p>
            <p className="mb-3">Instrucciones para los principales navegadores:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer nofollow" className="text-[#00e87a] hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer nofollow" className="text-[#00e87a] hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer nofollow" className="text-[#00e87a] hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer nofollow" className="text-[#00e87a] hover:underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">4. Cookies de terceros</h2>
            <p>
              Algunos de nuestros socios pueden establecer cookies en su dispositivo cuando visita nuestra Plataforma. No tenemos control sobre estas cookies de terceros. Para más información, consulte las políticas de privacidad de dichos terceros.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">5. Actualizaciones de esta política</h2>
            <p>
              Podemos actualizar esta Política de Cookies para reflejar cambios en las cookies que utilizamos o por otras razones operativas, legales o reglamentarias. Le recomendamos que revise esta página periódicamente para estar informado sobre nuestro uso de cookies.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">6. Contacto</h2>
            <p>
              Si tiene alguna pregunta sobre nuestro uso de cookies, puede contactarnos en{' '}
              <a href="mailto:apuestamente@gmail.com" className="text-[#00e87a] hover:underline">
                apuestamente@gmail.com
              </a>.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
